export default __webpack_public_path__ + "static/media/reports.fe2679a2.png";